<template>
  <div class="container">
    <iframe id="ifr" :src="ifrm" frameborder="0"></iframe>

    <audio
      class="audio"
      id="audio1"
      :src="`${$cdn}audio/bg.mp3`"
      preload
      loop
      ref="musicBg"
    ></audio>

    <div class="introduce">
      <h1 v-if="!openIntro" @click="openIntro=!openIntro">三亚国际免税城旅游区
        <img :src="`${$cdn}images/icon_scene_tit_arrow@2x.png`" alt="">
      </h1>

      <div class="open" v-else @click="openIntro=!openIntro">
        <span >三亚国际免税城旅游区</span><img :src="`${$cdn}images/icon_scene_tit_arrow@2xtop.png`" alt="">
        <p @click.stop class="intro">三亚国际免税城旅游区位于海南省三亚市国家海岸海棠湾内，是集免税购物、有税购物、餐饮娱乐、文化展示、旅游休闲于一身的国际化综合度假目的地，是中、高端旅游者必游的海南景点。</p>
      </div>
    </div>

    <div class="back">
        <img @click.stop="$router.push({path:'/'})" :src="`${$cdn}images/${isMobile?'mobile/icon_mscene_back@2x':'icon_scene_back@2x'}.png`" alt />
    </div>

    <div class="map">
        <img @click="$intro({type:'map'})" :src="`${$cdn}images/maps_01@2x.png`" alt />
    </div>

    <div class="overlook">
        <img @click="showList('data')" :src="`${$cdn}images/menu_overlook@2x.png`" alt />
        <span>航拍</span>
    </div>

    <div class="overlook panorama">
        <img @click="showList('inner')" :src="`${$cdn}images/menu_panorama@2x.png`" alt />
        <span>游程线路</span>
    </div>

    <div class="darknight">
        <img @click="darknight=!darknight" :src="`${$cdn}images/${darknight?'switch_default':'switch_darkmode'}@2x.png`" alt />
    </div>

    <ul class="aside">
      <li @click="handleItemaside(item)" v-for="(item,i) in aside" :key="i" class>
        <img v-if="item.id === 'yinyue' && musicSta" :src="`${$cdn}images/listaside/nav_music_off@2x.png`" alt="">
        <img v-else :src="`${$cdn}images/listaside/${item.name}.png`" alt />
        <span>{{item.txt}}</span>
      </li>
    </ul>

   <template v-if="listVisable">
    <listSwiper
          v-if="isMobile"
          @handleItem="handleItem"
          :data="type==='data'?data:inner"
          :active="listactive"
        />
    <div class="list" v-else>
      <ul>
        <li :class="{active:listactive===item.url}" @click="handleItem(item)" v-for="(item,i) in type==='data'?data:inner" :key="i">
          <img :src="item.image" alt="">
          <span>{{item.text}}</span>
        </li>
      </ul>
    </div>
   </template>
  </div>
</template>

<script>
import listSwiper from "@/components/listSwiper";
import { raw,data,inner} from "@/components/data";
import browser from '@/utils/browser'
import {copyTextToClipboard} from '@/utils/index'


const aside = [
  {
    id: "fenxiang",
    name: "nav_share@2x",
    txt:'分享'
  },
  {
    id: "yinyue",
    name: "nav_music@2x",
    txt:'音乐'
  },
  // {
  //   id: "daolan",
  //   name: "nav_navigation@2x",
  //   txt:'导航'
  // }
];
export default {
  name: "Home",
  props:['musicStatus'],
  data() {
    return {
      data,
      inner,
      type:'data',
      openIntro:false,
      active: false,
      listactive: this.$route.query.url || data[0].url,
      darknight:true,
      aside,
      listVisable: false,
      detailVisable: false,
      isMobile: browser.mobile,
      activeType: "",
      activeDetail: "",
      musicSta: this.musicStatus,
      mus: "",
      ifr: this.$route.query.url || data[0].url
    };
  },
  watch: {
    musicSta(val) {
      this.$emit('audio',val)
    },
    darknight(val){
      let ifr = document.getElementById('ifr')
      let name = 'scene_' + (val ? this.listactive:(this.listactive + '2'))
      ifr.contentWindow.krpanoLoadScene(name)
    }
  },
  computed: {
    ifrm(){
      let url =  "https://houseoss.4dkankan.com/syms/panorama/"+this.ifr+"/tour.html" + (this.darknight?'':'?startscene=1')
      return url
    }
  },
  components: {
    listSwiper
  },
  methods: {
    showList(type){
      if (!this.listVisable) {
          this.type = type
          return this.listVisable = true
      }
      if (type === this.type) {
        this.listVisable=!this.listVisable
      }
      this.type = type
    },
    handleItem(item) {
      if (item.type === 'inner') {
          this.$router.push({name:'innerList',params:{url:item.tag}})
        return 
      }
      this.listactive = item.url
      this.ifr = item.url
    },
    handleItemaside(item){
      if (item.id === "fenxiang") {
        this.isMobile ? this.$share(): copyTextToClipboard(window.location.href,(data)=>{
          if (data === 'success') {
            return this.$tips({msg:'链接已成功复制'})
          }
          return this.$tips({msg:'链接复制失败'})
        })
      }
      if (item.id === "yinyue") {
        this.musicSta = !this.musicSta
      }
      if (item.id === "daolan") {
        if (this.ifr === data[0].url) {
          return this.$tips({msg:'您已经处于免税城正门位置'})
        }
        this.handleItem(data[0])
      }
    }
  },
  mounted() {
    window.addEventListener('message',data=>{
      if (Object.prototype.toString.call(data.data)=="[object String]") {
        let acItem = raw.find(item=>item.tag === data.data) || data[0]
        if (!acItem) {
          return
        }
        if (acItem.type === "overlook") {
           this.handleItem(acItem)
        }
        if (acItem.type === "inner") {
          this.$router.push({name:'innerList',params:{url:data.data}})
        }
        if (acItem.type === "newTab") {
          this.$router.push({name:'scene',params:{url:data.data}})
          // window.open(acItem.url,"_blank")
        }
      }
    })
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }

  .introduce{
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    h1{
      color: #fff;
      letter-spacing: 1px;
      font-size: 18px;
      font-weight: normal;
      line-height: 48px;
      height: 48px;
      min-width: 390px;
      text-align: center;
      position: relative;
      background: linear-gradient(89deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 29%, rgba(0, 0, 0, 0.2) 69%, rgba(0, 0, 0, 0) 100%);
      img{
        position: absolute;
        width: 12px;
        right: 110px;
        top: 50%;
        transform: translateY(-50%);
        left: unset;
      }
    }
    .open{
      text-align: center;
      border: 2px solid rgba(255, 255, 255, 0.3);
      width: 200px;
      line-height: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 20px;
      color: #fff;
      position: relative;
       img{
        position: absolute;
        width: 14px;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        left: unset;
      }
      .intro{
        background: rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        width: 280px;
        position: absolute;
        padding: 14px 16px;
        line-height: 1.5;
        text-align: justify;
        font-size: 14px;
        top: 48px;
        cursor: auto;
      }
    }
  }

  .back{
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 999;
    img{
      width: 48px;
    }
  }
  
  .overlook{
    position: absolute;
    bottom: 40px;
    left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img{
      cursor: pointer;
      width: 48px;
    }
    span{
      color: #fff;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      margin-top: 4px;
    }
  }

  .panorama{
    left: 100px;
  }

  .darknight{
    position: absolute;
    bottom: 76px;
    left: 50%;
    transform: translateX(-50%);
    img{
      width: 88px;
      cursor: pointer;
    }
  }

  .map{
    position: absolute;
    top: 100px;
    right: 30px;
    img{
      cursor: pointer;
      width: 100px;
    }
  }

  .aside {
    position: fixed;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    li {
      cursor: pointer;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 64px;
      }
      span{
        text-align: center;
        color: #fff;
        margin-top: 2px;
        font-size: 14px;
      }
    }
  }

  .list{
    position: fixed;
    bottom: 120px;
    width: 100%;
    background: rgba(0, 0, 0, 0.3);
    >ul{
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      >li{
        font-size: 0;
        width: 142px;
        margin: 0 5px;
        position: relative;
        border: solid 2px rgba(0, 0, 0, 0);
        border-radius: 8px;
        overflow: hidden;
        >img{
          width: 100%;
          cursor: pointer;
        }
        >span{
          position: absolute;
          bottom: 0;
          left: 0;
          // background: rgba(0, 0, 0, 0.5);
          width: 100%;
          color: #fff;
          font-size: 14px;
          text-align: center;
        }
      }
      .active{
          border: solid 2px #E6C78E;
          border-radius: 8px;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .container {
    max-width: 500px;
    .introduce{
      z-index: 999;
      top: 10px;
      h1{
        min-width: 310px;
        line-height: 40px;
        height: 40px;
        img{
          position: absolute;
          width: 12px;
          right: 60px;
          transform: translateY(-50%);
          left: unset;
        }
      }
    }
    .map{
      top: 70px;
      right: 20px;
      img{
        width: 90px;
      }
    }
    .aside {
      top: 180px;
      transform: translateY(0);
      right: 20px;
      li {
        margin-top: 15px;
        img {
          width: 44px;
        }
      }
    }

    .home_btn{
      bottom: 64px;
      img{
        width: 144px;
      }
    }
  .back{
      position: absolute;
      top: 16px;
      left: 32px;
      img{
        width: 30px;
      }
    }
    
  .overlook{
      bottom: 30px;
      left: 20px;
      img{
        width: 44px;
      }
    }

  .panorama{
    left: 80px;
  }
  }
  .container{
    .darknight{
      bottom: 50px;
      right: 20px;
      left: unset;
      transform: translateX(0);
      img{
        width: 88px;
        cursor: pointer;
      }
    }
  }
}
</style>